import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
interface MyProps {callback:Function}
interface MyState { }
class BlockScreen extends Component<MyProps, MyState>
{
    constructor(props: MyProps) {
        super(props);
        this.state = {};
    }
    render() {
        return (<div><div className='shade' onClick={()=>{this.props.callback()}}></div>
            <div className='gen-screen'>
                <h2>Pro App</h2>
                <Row>
                    <Col sm={12}>
                        <p>This app is only available to paid members. </p><Button variant='link' onClick={()=>{alert("Sign Up")}}> Sign up here</Button>
                        <hr />
                        <Button className="gen-screen__button" onClick={() => { this.props.callback() }}>OK</Button>
                    </Col>
                </Row>
            </div></div >)
    }
}
export default BlockScreen;